import Vue from 'vue';
import _indexOf from 'lodash/indexOf'

export const Can = {
    inserted: function (el, binding) {





        var temp,
            tKey,
            obj = window.V.acl.permissions,
            multipart = [];

        //console.log('permissions',window.V.acl.permissions)

        if (obj) {

            if (binding.value.indexOf('||') !== -1) {
                multipart = binding.value.split(' || ');
            }
            else {
                multipart.push(binding.value);
            }


            var oneOk = false;

            for (var mKey in multipart) {
                if (_indexOf(obj, multipart[mKey]) != -1) {
                    oneOk = true;
                }
            }

            if (oneOk !== true) {
                el.style.display = 'none';
            }
            else {
                el.style.display = 'normal';
            }


        }


    },

    update: function (el, binding) {
        var temp,
            tKey,
            obj = window.V.acl.permissions,
            multipart = [];


        if (obj) {

            if (binding.value.indexOf('||') !== -1) {
                multipart = binding.value.split(' || ');
            }
            else {
                multipart.push(binding.value);
            }


            var oneOk = false;

            for (var mKey in multipart) {
                if (_indexOf(obj, multipart[mKey]) != -1) {
                    oneOk = true;
                }
            }

            if (oneOk !== true) {
                el.style.display = 'none';
            }
            else {
                el.style.display = 'normal';
            }


        }
    }

}

Vue.directive('can', Can)